import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { createSelector, Store } from '@ngrx/store';
import { FreyaCommonModule } from 'src/app/freya-common/freya-common.module';
import { CANADA, countries, regex } from 'src/app/global.constants';

import { LibModule } from 'src/app/lib.ts/lib.module';
import { SharedModule } from 'src/app/shared/shared.module';

import { jobToolFeature } from '../../job-tool.reducer';

import { JobManuallyAddLocationActions } from './job-manually-add-location.actions';

@Component({
  selector: 'app-job-manually-add-location',
  standalone: true,
    imports: [
        FreyaCommonModule,
        ReactiveFormsModule,
        LibModule,
        SharedModule,
    ],
  templateUrl: './job-manually-add-location.component.html',
  styleUrls: ['./job-manually-add-location.component.scss']
})
export class JobManuallyAddLocationComponent {

    public countries = countries;

    public viewModel$ = this.store.select(createSelector(
      jobToolFeature.selectManuallyAddLocationDialog,
      jobToolFeature.selectManuallyAddLocationDialogVisible,
      (manuallyAddLocationDialog, visible) => {

        const areaCodePattern = manuallyAddLocationDialog.country === CANADA ? regex.areaCodeCanada : regex.areaCodeUSA;

        const requiredFields: (keyof typeof manuallyAddLocationDialog)[] = [
          'streetNumber',
          'streetName',
          'areaCode',
          'city',
          'country',
          'jurisdiction',
        ];

        const allRequiredFieldsCompleted = requiredFields
          .every((f) => manuallyAddLocationDialog[f]);

        return {
          ...manuallyAddLocationDialog,
          visible,
          areaCodePattern,
          canAddLocation: allRequiredFieldsCompleted && new RegExp(areaCodePattern).test(manuallyAddLocationDialog.areaCode),
        }
      }
    ));

    public actions = JobManuallyAddLocationActions;

    constructor(
      public store: Store,
    ) { }
}
